import {sortArrayByKey} from "./shared/functions";

/**
 * Post-Process incoming list or item data
 *
 * @param resource
 * @param type
 * @param params
 * @param rdata
 *
 * @return {*}
 */
export const postProcessData = (resource, type, params, rdata) => {
    if (type === 'GET_LIST') {

        // Filter data if filters are present
        if (params.filter) {
            rdata = filterListData(resource, type, params, rdata);
        }

        // Sort data according to sort parameters
        if (params.sort.field && params.sort.order) {
            rdata = sortListData(resource, type, params, rdata);
        }

        // Pagination will not be handled here as page will be 1 and all data is returned

    }
    if (type === 'GET_ONE') {
        if (resource === 'Sysops' || resource === 'Sysadmins' || resource === 'Sysusers') {
            rdata = processUserData(rdata);
        }
    }
    return rdata;
};

/**
 * Filter incoming data
 *
 * @param resource
 * @param type
 * @param params
 * @param rdata
 * @return {*}
 */
const filterListData = (resource, type, params, rdata) => {
    let filteredData;
    let filteredIds;

    // Handle filtering for Sysop-only or Sysadmin-only
    if (resource === 'Sysops' || resource === 'Sysadmins') {
        if (params.filter.role) {
            filteredData = [];
            filteredIds = [];
            for (let f = 0; f < rdata.data.length; f++) {
                if (rdata.data[f][params.filter.role] === true) {
                    filteredData.push(rdata.data[f]);
                    const idItem = matchArrayElements(rdata.ids, rdata.data[f]['email']);
                    filteredIds.push(idItem);
                }
            }
            rdata.data = filteredData;
            rdata.ids = filteredIds;
            rdata.total = filteredIds.length;
        }
    }
    // Handle filtering for Sysuser-only (non-Sysop, non-Admin)
    if (resource === 'Sysusers') {
        if (params.filter.role) {
            filteredData = [];
            filteredIds = [];
            for (let f = 0; f < rdata.data.length; f++) {
                if (rdata.data[f]['sys_op'] === false && rdata.data[f]['sys_admin'] === false) {
                    filteredData.push(rdata.data[f]);
                    const idItem = matchArrayElements(rdata.ids, rdata.data[f]['email']);
                    filteredIds.push(idItem);
                }
            }
            rdata.data = filteredData;
            rdata.ids = filteredIds;
            rdata.total = filteredIds.length;
        }
    }
    return rdata;
};

/**
 * Locate an item in one array from another array's element
 *
 * @param arr
 * @param el
 * @return {*}
 */
const matchArrayElements = (arr, el) => {
    return arr.find(k => k === el);
};

/**
 * Sort incoming data
 *
 * @param resource
 * @param type
 * @param params
 * @param rdata
 */
const sortListData = (resource, type, params, rdata) => {
    rdata.data = sortArrayByKey(rdata.data, params.sort.field, params.sort.order);
    return rdata;
};

/**
 * Process Sysop, SysAdmin, SysUser data after retrieval
 */
const processUserData = (rdata) => {
    // Convert form data to avoid autofill
    rdata.data.sys_id = rdata.data.id;
    rdata.data.sys_email = rdata.data.email;
    rdata.data.sys_password = rdata.data.password;
    rdata.data.sys_first_name = rdata.data.first_name;
    rdata.data.sys_last_name = rdata.data.last_name;
    
    delete rdata.data.password;
    delete rdata.data.first_name;
    delete rdata.data.last_name;

    return rdata;
};

/* ID and Key exported functions ::::: */

/**
 * Generate a unique id for list items (per React's unique-key requirement)
 */
export const generateId = () => {
    let dt = new Date().getTime();
    const id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
    return id;
};

/**
 * Mark resources without ids or with different unique identifiers
 */
export const setUniqueKeys = (resource, type) => {
    const parseParams = {
        hasNameKeys: false,
        isArray: false,
        needsId: false,
        parentKey: null,
        idKey: null,
    };
    if (resource === 'Systems') {
        parseParams.idKey = 'name';
    }
    if (resource === 'Sysops' || resource === 'Sysadmins' || resource === 'Sysusers') {
        parseParams.idKey = 'email';
    }
    return parseParams;
};

/* Miscellaneous functions ::::: */



// WEBPACK FOOTER //
// ./src/Fuse/restClientPostProcess.js